// LLM Settings
export const GET_ALL_LLM_SETTINGS = 'GET_ALL_LLM_SETTINGS'
export const CREATE_LLM_SETTING = 'CREATE_LLM_SETTING'
export const UPDATE_LLM_SETTING = 'UPDATE_LLM_SETTING'
export const DELETE_LLM_SETTING = 'DELETE_LLM_SETTING'
export const ACTIVATE_LLM_SETTING = 'ACTIVATE_LLM_SETTING'
export const GET_LLM_PROVIDERS = 'GET_LLM_PROVIDERS'

export const UPDATE_LOGGED_IN_USER = 'UPDATE_LOGGED_IN_USER'
export const USER_LOGOUT = 'USER_LOGOUT'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_MOBILE_ADMIN = 'TOGGLE_MOBILE_ADMIN'
export const GET_USERS = 'GET_USERS'
export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_STEPS = 'GET_STEPS'
export const ADD_STEPS = 'ADD_STEPS'
export const ADD_USERS = 'ADD_USERS'
export const GET_WORKFLOWS = 'GET_WORKFLOWS'
export const GET_ORGANIZATION = 'GET_ORGANIZATION'
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION'
export const PUT_ORGANIZATION = 'PUT_ORGANIZATION'
export const GET_ORG_COMPANIES = 'GET_ORG_COMPANIES'
export const GET_FUNCTION = 'GET_FUNCTION'
export const ADD_FUNCTION = 'ADD_FUNCTION '
export const GET_GROUP = 'GET_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
export const ONE_GROUP = 'ONE_GROUP'
export const ADD_FUNCTION_MAP = 'ADD_FUNCTION_MAP'
export const GET_FUNCTION_GROUP = 'GET_FUNCTION_GROUP'
export const ADD_GROUP_FUNCTION_MAP = 'ADD_GROUP_FUNCTION_MAP'
export const ADD_WORKFLOW = 'ADD_WORKFLOW'
export const GET_ROUTES = 'GET_ROUTES'
export const GET_CONFIGURATION = 'GET_CONFIGURATION'
export const ADD_WORKFLOW_ROUTE = 'ADD_WORKFLOW_ROUTE'
export const GET_WORKFLOW_REQ = 'GET_WORKFLOW_REQ'
export const GET_DURATION = 'GET_DURATION'
export const ADD_DURATION = 'ADD_DURATION'
export const GET_WORKROUTE = 'GET_WORKROUTE'
export const GET_CONFIGURATION_REQ = 'GET_CONFIGURATION_REQ'
export const GET_GROUPROUTE_DATA = 'GET_GROUPROUTE_DATA'
export const ADD_GROUPROUTE = 'ADD_GROUPROUTE'
export const GET_GROUPROUTEALL = 'GET_GROUPROUTEALL'
export const UPDATE_STEPS = 'UPDATE_STEPS'
export const ADD_GROUP = 'ADD_GROUP'
export const UPDATE_USERS = 'UPDATE_USERS'
export const GET_STEP_REG = 'GET_STEP_REG'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_CHANGE_PASSWORD = 'RESET_CHANGE_PASSWORD'
export const GET_ALL_DURATION_DETAILS = 'GET_ALL_DURATION_DETAILS'
export const ADD_DURATION_DETAILS = ' ADD_DURATION_DETAILS'
export const UPDATE_DURATION_DETAILS = 'UPDATE_DURATION_DETAILS'
export const GET_DURATION_DETAILS_BY_ID = 'GET_DURATION_DETAILS_BY_ID'
export const GET_REGULATORY_TYPES = 'GET_REGULATORY_TYPES'

//FORGET PASSWORD
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const FORGET_PASSWORD = 'FORGET_PASSWORD'

export const REGISTER = 'REGISTER'
export const EMAIL = 'EMAIL'
export const GET_GROUPS = 'GROUPS'
export const GET_DASHBOARD = 'GET_DASHBOARD'
export const GET_GROUP_BASED_USER_DETAILS = 'GET_GROUP_BASED_USER_DETAILS'
export const GET_ALL_USERS_DATA = 'GET_ALL_USERS_DATA'
export const GET_ALLCASES_MAP_DATA = 'GET_ALLCASES_MAP_DATA'
export const GET_FORMS = 'GET_FORMS'
export const GET_FIELDS_BY_FORM_ID = 'GET_FIELDS_BY_FORM_ID'
export const GET_ALL_FORMS_AND_FIELDS = 'GET_ALL_FORMS_AND_FIELDS'
export const GET_HISTORY = 'GET_HISTORY'
export const ADD_HISTORY = 'ADD_HISTORY'
export const UPDATE_READ = 'UPDATE_READ'
export const GET_CASE_HISTORY = 'GET_CASE_HISTORY'
export const ADD_CASE_HISTORY = 'ADD_CASE_HISTORY'
export const UPDATE_CASE_READ = 'UPDATE_CASE_READ'
export const GET_ONE_CASE = ' GET_ONE_CASE'

//States
export const GET_ALL_STATES = 'GET_ALL_STATES'
export const GET_COUNTRY_STATES = 'GET_COUNTRY_STATES'
//adminproduct
export const GET_ALL_PRODUCT = 'GET_ALL_PRODUCT'
export const GET_ALL_PRODUCT_LIST = 'GET_ALL_PRODUCT_LIST'
export const ADD_ADMIN_PRODUCT_SUB = 'ADD_ADMIN_PRODUCT_SUB'
export const GET_ALL_WHO_PRODUCT = 'GET_ALL_WHO_PRODUCT'
export const OLD_ADMINPRODUCT_VALUE = 'OLD_ADMINPRODUCT_VALUE'

export const GET_PRODUCT_REQ = 'GET_PRODUCT_REQ'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const GET_FORMS_FIELDS = 'GET_FORMS_FIELDS'
export const UPDATE_FIELDS = 'UPDATE_FIELDS'
export const GET_SECTIONS = 'GET_SECTIONS'
export const GET_GROUP_FUNCTION = 'GET_GROUP_FUNCTION'
export const ADD_CASES = 'ADD_CASES'
export const GET_ROUTE_CONFIG = 'GET_ROUTE_CONFIG'
export const GET_CASES = 'GET_CASES'
export const GET_CASEID = 'GET_CASEID'
export const GET_CASEDETAILSBYID = 'GET_CASEDETAILSBYID'
export const GET_SUBMIT_CASES = 'GET_SUBMIT_CASES'
export const GET_NEW_CASES = 'GET_NEW_CASES'
export const ADD_SECTION = 'ADD_SECTION'
export const DELETE_SECTION = 'DELETE_SECTION'
export const GET_ALL_GROUP = 'GET_ALL_GROUP'
export const UPDATE_CASES = 'UPDATE_CASES'
export const LOCK_CASES = 'LOCK_CASES'
export const UNLOCK_CASES = 'UNLOCK_CASES'
export const GET_ADMIN_CASES = 'GET_ADMIN_CASES'
export const GET_ONE_PRODUCT = 'GET_ONE_PRODUCT'
export const GET_ALL_WHO_STRENGTH_UNIT = 'GET_ALL_WHO_STRENGTH_UNIT'
export const GET_ALL_WHOC3_UNIT = 'GET_ALL_WHOC3_UNIT'
//Report Management
export const GET_ALL_QUERIES = 'GET_ALL_QUERIES'
export const ADD_QUERY = 'ADD_QUERY'
export const SET_SELECTED_TABLE = 'SET_SELECTED_TABLE'
export const SET_APPLIED_FIELDS_BY_TABLE = 'SET_APPLIED_FIELDS_BY_TABLE'
export const SET_WHERE_CONDITION = 'SET_WHERE_CONDITION'
export const SELECTED_FIELDS = 'SELECTED_FIELDS'
export const REPORT_TYPES = 'REPORT_TYPES'
export const GET_ALL_QUERY_TABLE = 'GET_ALL_QUERY_TABLE'
export const GET_QUERY_TABLE = 'GET_QUERY_TABLE'
export const GET_DYNAMIC_QUERY = 'GET_DYNAMIC_QUERY'
export const GET_QUERY = 'GET_QUERY'
export const GET_REPORT_GENERATOR = 'GET_REPORT_GENERATOR'
export const UPDATE_QUERY = 'UPDATE_QUERY'
export const CREATE_QUERY = 'CREATE_QUERY'
export const RESET_QUERY = 'RESET_QUERY'
export const SET_CONDITION_FIELDS = 'SET_CONDITION_FIELDS'
//Report Management
export const GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES'
export const GET_TEMPLATES = 'GET_TEMPLATES'
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const ADD_TEMPLATE = 'ADD_TEMPLATE'
export const DRAGUPDATE_STEPS = 'DRAGUPDATE_STEPS'
export const GET_SECTION = 'GET_SECTION'
export const UPDATE_FORM = 'UPDATE_FORM'
export const UPDATE_SECTION = 'UPDATE_SECTION'
export const GET_ALL_FIELDS = 'GET_ALL_FIELDS'
export const GET_ALL_FLAG = 'GET_ALL_FLAG'
export const GET_ALL_ADMIN_FLAG = 'GET_ALL_ADMIN_FLAG'
export const GET_ALL_ADMIN_FIELD = 'GET_ALL_ADMIN_FIELD'
export const GET_ALL_LABEL_FIELDS = 'GET_ALL_LABEL_FIELDS'
export const ADD_FIELD = 'ADD_FIELD'
export const GET_ALL_TYPEFIELD = 'GET_ALL_TYPEFIELD'
export const ADD_FIELD_TYPE = 'ADD_FIELD_TYPE'
export const GET_ONE_FIELD = 'GET_ONE_FIELD'
export const GET_ALL_RADIOS = 'GET_ALL_RADIOS'
export const ADD_RADIO = 'ADD_RADIO'
export const GET_ALL_CHECKBOX = 'GET_ALL_CHECKBOX'
export const ADD_CHECKBOX = 'ADD_CHECKBOX'
export const GET_ALL_SELECTBOX = 'GET_ALL_SELECTBOX'
export const ADD_SELECTBOX = 'ADD_SELECTBOX'
export const UPDATE_CHECKBOX = 'UPDATE_CHECKBOX'
export const UPDATE_RADIO = 'UPDATE_RADIO'
export const UPDATE_SELECTBOX = 'UPDATE_SELECTBOX'
export const UPDATE_CASES_DISPLAYNAME = 'UPDATE_CASES_DISPLAYNAME'
export const ADD_FLAGS = 'ADD_FLAGS'
export const UPDATE_ONE_FIELDS = 'UPDATE_ONE_FIELDS'
export const CREATE_GENERAL = 'CREATE_GENERAL'
export const GET_ALL_GENERAL = 'GET_ALL_GENERAL'
export const UPDATE_GENERAL = 'UPDATE_GENERAL'
export const INACTIVE_GENERAL = 'INACTIVE_GENERAL'
export const GET_ALL_LANGUAGE = 'GET_ALL_LANGUAGE'
export const GET_ALL_REPORT_REMINDER = 'GET_ALL_REPORT_REMINDER'
export const GET_ALL_SUBSCRIBE_CASES = 'GET_ALL_SUBSCRIBE_CASES'
///who drugs Action
export const GET_ALL_DRUG_DETAILS = 'GET_ALL_DRUG_DETAILS'
export const GET_DRUG_DETAILS = 'GET_DRUG_DETAILS'
export const GET_ALL_FORMULTION = 'GET_ALL_FORMULTION'
//
export const GET_REACTION_EVENT = 'GET_REACTION_EVENT'
export const GET_PRODUCT_SUBSTANCE = 'GET_PRODUCT_SUBSTANCE'
//MEDDRA DISEASE
export const GET_MEDDRA_DISEASE1 = 'GET_MEDDRA_DISEASE1'
export const GET_MEDDRA_DISEASE2 = 'GET_MEDDRA_DISEASE2'
export const GET_ALL_MEDRA_DISEASE = 'GET_ALL_MEDRA_DISEASE'
export const GET_MEDDRA_DISEASE = 'GET_MEDDRA_DISEASE'
export const GET_ALLCASES = 'GET_ALLCASES'
export const UPDATE_MEDDRA_CASES = 'UPDATE_MEDDRA_CASES'
export const MEDDRA_VERSION_SUMMARY = 'MEDDRA_VERSION_SUMMARY'

export const ADD_PRIMARY = 'ADD_PRIMARY'
export const ADD_EVENT = 'ADD_EVENT'
export const GET_ALL_COUNTRY = 'GET_ALL_COUNTRY'
export const GET_ALL_FORM_SELECTBOX = 'GET_ALL_FORM_SELECTBOX'
export const GET_ALL_FORM_RADIOS = 'GET_ALL_FORM_RADIOS'
export const GET_ALL_FORM_CHECKBOX = 'GET_ALL_FORM_CHECKBOX'
export const GET_SALUTATION = 'GET_SALUTATION'
export const GET_GENDER = 'GET_GENDER'
export const GET_REPORT_TYPE = 'GET_REPORT_TYPE'
export const GET_CASE_INFORMATION = 'GET_CASE_INFORMATION'
export const GET_OCCUPATION = 'GET_OCCUPATION'
export const GET_REPORTER_TYPE = 'GET_REPORTER_TYPE'
export const GET_INTERMEDIATORY = 'GET_INTERMEDIATORY'
export const GET_CONTACT_SOURCE = 'GET_CONTACT_SOURCE'
export const GET_REPORTER = 'GET_REPORTER'
export const GET_REPORTER_LANG = 'GET_REPORTER_LANG'
export const GET_MEDICAL_HEALTH = 'GET_MEDICAL_HEALTH'
export const GET_OUTCOME_REC = 'GET_OUTCOME_REC'
export const GET_SEVERITY = 'GET_SEVERITY'
export const GET_DONE = 'GET_DONE'
export const GET_ETHINCITY = 'GET_ETHINCITY'
export const GET_EXPOSURE_PREGNANCY = 'GET_EXPOSURE_PREGNANCY'
export const GET_PATIENT_AGE = 'GET_PATIENT_AGE'
export const GET_SOURCE_DATA = 'GET_SOURCE_DATA'
export const GET_SPECIFY = 'GET_SPECIFY'
export const GET_PREGNANCY_OOUTCOME = 'GET_PREGNANCY_OOUTCOME'
export const GET_DELEVERY = 'GET_DELEVERY'
export const GET_BIRTH_TYPE = '  GET_BIRTH_TYPE'
export const GET_CONTINUING = 'GET_CONTINUING'
export const GET_FETAL_OUTCOME = 'GET_FETAL_OUTCOME'
export const GET_CHAR_PRODUCT = 'GET_CHAR_PRODUCT'
export const GET_UNIT = 'GET_UNIT'
export const GET_NEW_DRUG_CLASSIFIC = 'GET_NEW_DRUG_CLASSIFIC'
export const GET_OTC_RISK_CLASSIFIC = 'GET_OTC_RISK_CLASSIFIC'
export const GET_ACCESS_OTC = 'GET_ACCESS_OTC'
export const GET_ACTION_TAKEN_PROD = 'GET_ACTION_TAKEN_PROD'
export const GET_DID_REACTN_ABATE = 'GET_DID_REACTN_ABATE'
export const GET_UNIT_MIN = 'GET_UNIT_MIN'
export const GET_UNIT_YR = 'GET_UNIT_YR'
export const GET_UNIT_HR = 'GET_UNIT_HR'
export const GET_RES_TO_FDA_REQ = 'GET_RES_TO_FDA_REQ'
export const GET_ACTION_TAKEN = 'GET_ACTION_TAKEN'
export const GET_REACT_EVOL_AFTER = 'GET_REACT_EVOL_AFTER'
export const GET_REACTION_RE_ADMIN = 'GET_REACTION_RE_ADMIN'
export const GET_CASE_PRODUCT_INFO = 'GET_CASE_PRODUCT_INFO'
export const GET_REACTION_RE_EVOLVE = 'GET_REACTION_RE_EVOLVE'
export const GET_PATIENT_INFO = 'GET_PATIENT_INFO'
export const GET_NARRATIVE_SUMMARY = 'GET_NARRATIVE_SUMMARY '
export const ADD_PRIMARY_CASE = 'ADD_PRIMARY_CASE'
export const GET_PRIMARY_SOURCE = 'GET_PRIMARY_SOURCE'
export const GET_CASE_EVENT_INFO = 'GET_CASE_EVENT_INFO'
export const ADD_CASE_PATIENT_PRAGNANCY = 'ADD_CASE_PATIENT_PRAGNANCY'
export const UPDATE_CASE_PATIENT_PRAGNANCY = 'UPDATE_CASE_PATIENT_PRAGNANCY'
export const GET_PRIMARY_REPORTED = 'GET_PRIMARY_REPORTED'
export const GET_PRIMARY_QUERY = ' GET_PRIMARY_QUERY'
export const UPDATE_CASE_REPORTER_INFO = ' UPDATE_CASE_REPOTER_INFO'
export const UPDATE_CASE_QUERY = ' UPDATE_CASE_QUERY'
export const GET_ALL_EVENT_DETAILS = 'GET_ALL_EVENT_DETAILS'
export const UPDATE_EVENT_DETAILS = 'ADD_EVENT_DEATIL'
export const INACTIVE_EVENT = 'INACTIVE_EVENT'
export const ADD_REACTION_DETAIL = 'ADD_REACTION_DETAIL'
export const UPDATE_CASES_ID = 'UPDATE_CASES_ID'
export const GET_PRODUCT_REACT = 'GET_PRODUCT_REACT'
export const ADD_PRODUCT_INFO = 'ADD_PRODUCT_INFO'
export const ADD_CASE_PATIENT_INFO = 'ADD_CASE_PATIENT_INFO'
export const UPDATE_CASE_PATIENT_INFO = 'UPDATE_CASE_PATIENT_INFO'
export const ADD_CASE_PATIENT_CHAR = 'ADD_CASE_PATIENT_CHAR'
export const UPDATE_CASE_PATIENT_CHAR = 'UPDATE_CASE_PATIENT_CHAR'
export const ADD_CASE_PATIENT_MEDICAL = 'ADD_CASE_PATIENT_MEDICAL'
export const UPDATE_CASE_PATIENT_MEDICAL = 'UPDATE_CASE_PATIENT_MEDICAL'
export const ADD_CASE_PATIENT_DRUG = 'ADD_CASE_PATIENT_DRUG'
export const UPDATE_CASE_PATIENT_DRUG = 'UPDATE_CASE_PATIENT_DRUG'
export const ADD_CASE_PATIENT_LAB = 'ADD_CASE_PATIENT_LAB'
export const UPDATE_CASE_PATIENT_LAB = 'UPDATE_CASE_PATIENT_LAB'
export const ADD_CASE_PARENT_INFO = 'ADD_CASE_PARENT_INFO'
export const UPDATE_CASE_PARENT_INFO = 'UPDATE_CASE_PARENT_INFO'
export const ADD_CASE_PARENT_MEDICAL = 'ADD_CASE_PARENT_MEDICAL'
export const UPDATE_CASE_PARENT_MEDICAL = 'UPDATE_CASE_PARENT_MEDICAL'
export const ADD_CASE_PARENT_DRUG = 'ADD_CASE_PARENT_DRUG'
export const UPDATE_CASE_PARENT_DRUG = 'UPDATE_CASE_PARENT_DRUG'
export const ADD_CASE_PARENT_LAB = 'ADD_CASE_PARENT_LAB'
export const UPDATE_CASE_PARENT_LAB = 'UPDATE_CASE_PARENT_LAB'
export const ADD_NARRATIVE = 'ADD_NARRATIVE'
export const ADD_NARRATIVE_SUM = 'ADD_NARRATIVE_SUM'
export const ADD_SENDER_SUMMARY = 'ADD_SENDER_SUMMARY'
export const UPDATE_NARRATIVE = 'UPDATE_NARRATIVE'
export const UPDATE_NARRATIVE_SUM = 'UPDATE_NARRATIVE_SUM'
export const UPDATE_SENDER_SUM = 'UPDATE_SENDER_SUM'
export const INACTIVE_NARRATIVE = 'ISACTIVE_NARRATIVE'
export const INACTIVE_NARRATIVE_SUM = 'ISACTIVE_NARRATIVE_SUM'
export const INACTIVE_SENDER_SUM = 'ISACTIVE_SENDER_SUM'
export const ADD_AUTOSPY_DETAIL = 'ADD_AUTOSPY_DETAIL'
export const UPDATE_AUTOSPY = 'UPDATE_AUTOSPY'
export const INACTIVE_AUTOSPY = 'INACTIVE_AUTOSPY'
export const ADD_REPORT_DEATH = 'ADD_REPORT_DEATH'
export const UPDATE_REPORT_DEATH = 'UPDATE_REPORT_DEATH'
export const INACTIVE_REPORT_DEATH = 'INACTIVE_REPORT_DEATH'
export const REACTION_EVENT_TRANLATE = 'REACTION_EVENT_TRANLATE'

export const GET_ALL_TIMER = ' GET_ALL_TIMER'
export const GET_MIGRATE_CASES = 'GET_MIGRATE_CASES'
//get product info and event for Mattrix

export const GET_ALL_PRODUCT_INFO = 'GET_ALL_PRODUCT_INFO'
export const GET_ALL_EVENT_INFO = 'GET_ALL_EVENT_INFO'
//Muni Added Product

//Product Info
export const GET_PRODUCT_INFO = 'GET_PRODUCT_INFO'
export const CREATE_BASIC_PRODUCT_INFO = 'CREATE_BASIC_PRODUCT_INFO'
export const UPDATE_BASIC_PRODUCT_INFO = 'UPDATE_BASIC_PRODUCT_INFO'
export const DELETE_BASIC_PRODUCT_INFO = 'DELETE_BASIC_PRODUCT_INFO'

//PRODUCT STUDY prodStudy

export const CREATE_PRODUCT_STUDY = 'CREATE_PRODUCT_STUDY'
export const UPDATE_PRODUCT_STUDY = 'UPDATE_PRODUCT_STUDY'
export const DELETE_PRODUCT_STUDY = 'DELETE_PRODUCT_STUDY'
export const GET_STUDY_MANAG_LIST = 'GET_STUDY_MANAG_LIST'

//arms
export const GET_ALL_ARMS_MANAGE = 'GET_ALL_ARMS_MANAGE'
export const ADD_ARMS_MANAGMENT = 'ADD_ARMS_MANAGMENT'
export const UPDATE_ARMS_MANAGMENT = 'UPDATE_ARMS_MANAGMENT'
export const GET_ARMS_BY_ID = 'GET_ARMS_BY_ID'
//Product ADMIN
export const CREATE_ADMIN_PRODUCT_INFO = 'CREATE_ADMIN_PRODUCT_INFO'
export const UPDATE_ADMIN_PRODUCT_INFO = 'UPDATE_ADMIN_PRODUCT_INFO'
export const DELETE_ADMIN_PRODUCT_INFO = 'DELETE_ADMIN_PRODUCT_INFO'

//Product Substances
export const CREATE_PRODUCT_SUB = 'CREATE_PRODUCT_SUB'
export const UPDATE_PRODUCT_SUB = 'UPDATE_PRODUCT_SUB'
export const DELETE_PRODUCT_SUB = 'DELETE_PRODUCT_SUB'

//Product Incrdient
export const CREATE_PRODUCT_INCRDIRNTINFO = 'CREATE_PRODUCT_INCRDIRNTINFO'
export const UPDATE_PRODUCT_INCRDIRNTINFO = 'UPDATE_PRODUCT_INCRDIRNTINFO'
export const DELETE_PRODUCT_INCRDIRNTINFO = 'DELETE_PRODUCT_INCRDIRNTINFO'
//search

export const GET_ALL_SEARCH = 'GET_ALL_SEARCH'

//Product Indication
export const CREATE_PRODUCT_IND = 'CREATE_PRODUCT_IND'
export const UPDATE_PRODUCT_IND = 'UPDATE_PRODUCT_IND'
export const DELETE_PRODUCT_IND = 'DELETE_PRODUCT_IND'

//Product FDA
export const CREATE_PRODUCT_FDA = 'CREATE_PRODUCT_FDA'
export const UPDATE_PRODUCT_FDA = 'UPDATE_PRODUCT_FDA'
export const DELETE_PRODUCT_FDA = 'DELETE_PRODUCT_FDA'

//Product EMA
export const CREATE_PRODUCT_EMA = 'CREATE_PRODUCT_EMA'
export const UPDATE_PRODUCT_EMA = 'UPDATE_PRODUCT_EMA'
export const DELETE_PRODUCT_EMA = 'DELETE_PRODUCT_EMA'

//Product QC
export const CREATE_PRODUCT_QC = 'CREATE_PRODUCT_QC'
export const UPDATE_PRODUCT_QC = 'UPDATE_PRODUCT_QC'
export const DELETE_PRODUCT_QC = 'DELETE_PRODUCT_QC'

//Product Device
export const CREATE_PRODUCT_DEVICE = 'CREATE_PRODUCT_DEVICE'
export const UPDATE_PRODUCT_DEVICE = 'UPDATE_PRODUCT_DEVICE'
export const DELETE_PRODUCT_DEVICE = 'DELETE_PRODUCT_DEVICE'

//product Device Manufacturer
export const CREATE_DEVICE_MANUFACTURER = 'CREATE_DEVICE_MANUFACTURER'
export const UPDATE_DEVICE_MANUFACTURER = 'UPDATE_DEVICE_MANUFACTURER'
export const DELETE_DEVICE_MANUFACTURER = 'DELETE_DEVICE_MANUFACTURER'

//Product Dosage
export const CREATE_PRODUCT_DOSE = 'CREATE_PRODUCT_DOSE'
export const UPDATE_PRODUCT_DOSE = 'UPDATE_PRODUCT_DOSE'
export const DELETE_PRODUCT_DOSE = 'DELETE_PRODUCT_DOSE'
//Muni Added product end

export const ADD_PRODUCT_REACTION_INFO = 'ADD_PRODUCT_REACTION_INFO'
export const ADD_ASSESSMENT = 'ADD_ASSESSMENT'
export const ADD_DIAGNOSIS = 'ADD_DIAGNOSIS'
export const UPDATE_PRODUCT_REACTION_INFO = 'UPDATE_PRODUCT_REACTION_INFO'
export const UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT'
export const UPDATE_DIAGNOSIS = 'UPDATE_DIAGNOSIS'
export const INACTIVE_PRODUCT_REACTION_INFO = 'INACTIVE_PRODUCT_REACTION_INFO'
export const INACTIVE_ASSESSMENT = 'INACTIVE_ASSESSMENT'
export const INACTIVE_DIAGNOSIS = 'INACTIVE_DIAGNOSIS'
export const ADD_PRODUCT_ADMIN = 'ADD_PRODUCT_ADMIN'
export const ADD_PRODUCT_SUB = 'ADD_PRODUCT_SUB'
export const ADD_PRODUCT_IND = 'ADD_PRODUCT_IND'
export const ADD_PRODUCT_ADMININFO = 'ADD_PRODUCT_ADMININFO'
export const ADD_PRODUCT_FDA = 'ADD_PRODUCT_FDA'
export const ADD_PRODUCT_EMA = 'ADD_PRODUCT_EMA'
export const ADD_PRODUCT_QC = 'ADD_PRODUCT_QC'
export const ADD_PRODUCT_DOASGE = 'ADD_PRODUCT_ADD_PRODUCT_DOASGE'
export const GET_PRODUCT_ALL = 'GET_PRODUCT_ALL'
export const GET_ALL_ADMIN_PRODUCT = 'GET_ALL_ADMIN_PRODUCT'
export const UPDATE_PRODUCT_INFO = 'UPDATE_PRODUCT_INFO'
export const GET_PRODUCT_SUB = 'GET_PRODUCT_SUB'
export const GET_TESTRESULT = 'GET_TESTRESULT'
export const GET_STUDY_MANAG = 'GET_STUDY_MANAG'
export const UPDATE_STUDY_MANAGMENT = ' UPDATE_STUDY_MANAGMENT'
export const ADD_STUDY_MANAGMENT = 'ADD_STUDY_MANAGMENT'
export const GET_STUDY_BY_ID = 'GET_STUDY_BY_ID'
export const GET_INSTITUTION = ' GET_INSTITUTION'
export const ADD_INSITITUTION = 'ADD_INSITITUTION'
export const UPDATE_INSTITUTION = 'UPDATE_INSTITUTION'
export const GET_LITERATURE = 'GET_LITERATURE'
export const UPDATE_LITERATURE = 'UPDATE_LITERATURE'
export const GET_INSTITUTION_BY_ID = 'GET_INSTITUTION_BY_ID'
export const GET_SENDER_DETAILS = ' GET_SENDER_DETAILS,'
export const ADD_SENDER_DETAILS = ' ADD_SENDER_DETAILS'
export const UPDATE_SENDER_DETAILS = '  UPDATE_SENDER_DETAILS'
export const GET_SENDER_DETAILS_BY_ID = 'GET_SENDER_DETAILS_BY_ID'
export const GET_RECEIVER_DETAILS_BY_ID = 'GET_RECEIVER_DETAILS_BY_ID'
export const ADD_RECEIVER_DETAILS = ' ADD_RECEIVER_DETAILS'
export const UPDATE_RECEIVER_DETAILS = ' UPDATE_RECEIVER_DETAILS'
export const GET_RECEIVER_DETAILS = ' GET_RECEIVER_DETAILS'
export const GET_ALL_DURATIONS_DETAILS = 'GET_ALL_DURATIONS_DETAILS'
//xml
export const CREATE_XMLGENERATOR = 'CREATE_XMLGENERATOR'
// PDF
export const CREATE_PDFGENERATOR = 'CREATE_PDFGENERATOR '
// case template
export const GET_CASE_TEMPLATE = 'GET_CASE_TEMPLATE'
export const CASE_GET_ALL_TEMPLATES = 'CASE_GET_ALL_TEMPLATES'
export const CASE_ADD_TEMPLATE = 'CASE_ADD_TEMPLATE'
export const CASE_UPDATE_TEMPLATE = 'CASE_UPDATE_TEMPLATE'
export const CASE_TEMPALTE_DETAILS = 'CASE_TEMPALTE_DETAILS'
export const CASE_GET_TEMPLATE = 'CASE_GET_TEMPLATE'
export const XML_SUBMISSION = 'XML_SUBMISSION'

//s3 Upload files
export const UPLOAD_S3FILES = 'UPLOAD_S3FILES'
export const GET_S3FILES = 'GET_S3FILES'

//dashboard export pdf (dedicated S3 controller, separate from generic s3 uploads)
export const DASHBOARD_EXPORT_PDF_UPLOAD_SUCCESS = 'DASHBOARD_EXPORT_PDF_UPLOAD_SUCCESS'
export const DASHBOARD_EXPORT_PDF_DOWNLOAD_SUCCESS = 'DASHBOARD_EXPORT_PDF_DOWNLOAD_SUCCESS'
//duplicate check

export const GET_DUPLICATE_CHECK = 'GET_DUPLICATE_CHECK'
export const ADD_DUPLICATE_WEIGHTAGE = 'ADD_DUPLICATE_WEIGHTAGE'

export const PERMITDUPLICATECHECK = 'PERMITDUPLICATECHECK'
export const UPDATE_DUPCHECK_WEIGHTAGE = 'UPDATE_DUPCHECK_WEIGHTAGEs'
export const GET_DUPLICATE_FIELD_WEIGHTAGE = 'GET_DUPLICATE_FIELD_WEIGHTAGE'
export const UPDATE_DUplicate_FIELD_WEIGHTAGE =
  'UPDATE_DUplicate_FIELD_WEIGHTAGE'

export const CLONE_CASEINFO = 'CLONE_CASEINFO'
export const ADD_VERSION = 'ADD_VERSION'

/// ******************MedWatch**********CIMOS******************** ////

export const GET_MEDWATCH_DETAILS = ' GET_MEDWATCH_DETAILS'
export const ADD_MEDWATCH_DETAILS = 'ADD_MEDWATCH_DETAILS '
export const GET_CIMOS_DETAILS = 'GET_CIMOS_DETAILS'
export const ADD_CIMOS_DETAILS = ' ADD_CIMOS_DETAILS'

/// ******************regulatory**********Report******************** ////

export const GET_ALL_REPORT_DETAILS = ' GET_AA_REPORT_DETAILS'
export const ADD_REPORT_DETAILS = 'ADD_REPORT_DETAILS '
export const GET_ONE_REPORT_DETAILS = 'GET_ONE_REPORT_DETAILS'
export const UPDATE_REPORT_DETAILS = ' UPDATE_REPORT_DETAILS'
export const GET_ONE_REPORT_ID_NULL = ' GET_ONE_REPORT_ID_NULL'

export const DOWNLOAD_REPORT_DETAILS = 'DOWNLOAD_REPORT_DETAILS'
export const DOWNLOAD_REPORT_DETAILS_EXCEL = 'DOWNLOAD_REPORT_DETAILS_EXCEL'
export const DOWNLOAD_AGGREGATE_REPORT = 'DOWNLOAD_AGGREGATE_REPORT'

export const GET_ALL_REPORT_DETAILS_FILE_LISTING =
  'GET_ALL_REPORT_DETAILS_FILE_LISTING'

/// ******************CASE FREEZE**********CASE_FREEZE******************** ////

export const CASE_FREEZE = 'CASE_FREEZE'
export const CREATE_CASEVERSIONS = 'CREATE_CASEVERSIONS'
export const GET_ALL_LIST = 'GET_ALL_LIST'

//history old value
export const OLD_GENERALVALUE = 'OLD_GENERALVALUE'
export const OLD_REPORTVALUE = 'OLD_REPORTVALUE'
export const OLD_PATIENTVALUE = 'OLD_PATIENTVALUE'
export const OLD_PRODUCTVALUE = 'OLD_PRODUCTVALUE'
export const OLD_EVENTVALUE = 'OLD_EVENTVALUE'
export const OLD_REACTIONVALUE = 'OLD_REACTIONVALUE'
export const OLD_NARRATIVEVALUE = 'OLD_NARRATIVEVALUE'

//*********** Case Submission **********//

export const GET_SUBMISSION_DETAILS = ' GET_SUBMISSION_DETAILS'
export const ADD_SUBMISSION_DETAILS = ' ADD_SUBMISSION_DETAILS'
export const UPDATE_SUBMISSION_DETAILS = ' UPDATE_SUBMISSION_DETAILS'
export const GET_CASE_SUBMITTED_DETAILS = 'GET_CASE_SUBMITTED_DETAILS'

/// ****************** XML MIGRATE***************************** ////

export const XML_UPLOAD = 'XML_UPLOAD'

/// ****************** active user case***************************** ////

export const ACTIVE_USER_COUNT = 'ACTIVE_USER_COUNT'

export const DELETE_ACTIVE_USERCOUNT = 'DELETE_ACTIVE_USERCOUNT'

//Customise table
export const GET_CUSTOMISE_TABLE = 'GET_CUSTOMISE_TABLE'
export const UPDATE_CUSTOMISE_TABLE = 'UPDATE_CUSTOMISE_TABLE'
export const GET_ALL_CUSTOMISETABLES = 'GET_ALL_CUSTOMISETABLES'

//Duplicate Check
export const CREATE_DUPLICATE = 'CREATE_DUPLICATE'
export const UPDATE_DUPLICATE = 'UPDATE_DUPLICATE'
export const GET_DUPLICATE = 'GET_DUPLICATE'
export const GET_ONE_DUPLICATE = 'GET_ONE_DUPLICATE'

//USER LINK EXPERIED

export const GET_USER_DATA = 'GET_USER_DATA'
export const UPDATE_USER_ACTIVATION_LINK = 'UPDATE_USER_ACTIVATION_LINK'
export const LIST_OF_USERS = 'LIST_OF_USERS'

// case xml migration load case
export const XML_MIGRATION = 'XML_MIGRATION'
export const COMPARE_XML = 'COMPARE_XML'

//
export const IS_CASE_PAGE = 'IS_CASE_PAGE'
export const REPORTER_IS_PRIMARY = 'REPORTER_IS_PRIMARY'

export const GET_CASES_LIST = 'GET_CASES_LIST'
export const GET_PERMISSION_CASES = 'GET_PERMISSION_CASES'
//SEARCH INDICATION

export const GET_ALL_INDICATION = 'GET_ALL_INDICATION'
export const GET_ALL_INDICATION_SEARCH = 'GET_ALL_INDICATION_SEARCH'

//GET DATA ADMINB

export const GET_DATA_ADMIN_CASE = 'GET_DATA_ADMIN_CASE'

//STEPS BASED PROCEDURE

export const GET_STEPS_PROCEDURE = 'GET_STEPS_PROCEDURE'
export const USER_PROFILE = 'USER_PROFILE'
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const ADMIN_CASE_TIMEINFO = 'ADMIN_CASE_TIMEINFO'
export const GET_CASETIME_INFO_BY_ID = 'GET_CASETIME_INFO_BY_ID'
export const CLEAR_CASE_TIME_INFO = 'CLEAR_CASE_TIME_INFO'

// CASE NOTIFICATION
export const GET_ALL_NOTIFICATION = 'GET_ALL_NOTIFICATION'

//// VERSIONED
export const GET_ALL_MEDDRA_VERSIONS = 'GET_ALL_MEDDRA_VERSIONS'
export const GET_ALL_MIGRATED_MEDDARA_VERSIONS =
  'GET_ALL_MIGRATED_MEDDARA_VERSIONS'
export const UPDATE_VERSIONS = 'UPDATE_VERSIONS'
export const UPLOAD_MEDDRA_DETAILS = 'UPLOAD_MEDDRA_DETAILS'
export const PREVIEW_MEDDRA_CHANGES = 'PREVIEW_MEDDRA_CHANGES'
export const APPLY_MEDDRA_CHANGES = 'APPLY_MEDDRA_CHANGES'
export const GET_DETAILED_CHANGES = 'GET_DETAILED_CHANGES'
export const GET_AFFECTED_CASES_REPORT = 'GET_AFFECTED_CASES_REPORT'
export const SAVE_LLT_RECORDS = 'SAVE_LLT_RECORDS'
export const PUPMED_SEARCH = 'PUPMED_SEARCH'
//Case Triaged
export const GET_TRIAGE_CASES = 'GET_TRIAGE_CASES'
export const GET_TRIAGE_DETAILS = 'GET_TRIAGE_DETAILS'
export const GET_CONSUMER_DETAILS = 'GET_CONSUMER_DETAILS'

/// Allocation
export const GET_ALLOCATION_CASE = 'GET_ALLOCATION_CASE'
export const GET_WORKFLOW_USERS = 'GET_WORKFLOW_USERS'
export const GET_ASSIGNED_CASE = 'GET_ASSIGNED_CASE'
/// Consumer
export const ADD_ADR_DETAILS = 'ADD_ADR_DETAILS'
export const ADD_ADRRF_FORM = 'ADD_ADRRF_FORM'
export const GET_ADRRF_CASE = 'GET_ADRRF_CASE'
export const VOLUNTARY_ADRRF = 'VOLUNTARY_ADRRF'
//INACTIVE CASES
export const GET_CASEINACTIVEDETAILS = 'GET_CASEINACTIVEDETAILS'
export const GET_ALL_USERS_LIST = 'GET_ALL_USERS_LIST'

/// Consumer
export const GET_USER_MESSAGES = 'GET_ALL_USER_MESSAGES'
export const ADD_USER_MESSAGE = 'ADD_USER_MESSAGE'
export const ADD_ADMIN_MESSAGE = 'ADD_ADMIN_MESSAGE'
export const UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS'
export const SET_SOCKET_CONNECTION_STATUS = 'SET_SOCKET_CONNECTION_STATUS'
export const SET_TYPING_INDICATOR = 'SET_TYPING_INDICATOR'
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS'
export const REMOVE_OPTIMISTIC_MESSAGE = 'REMOVE_OPTIMISTIC_MESSAGE'
export const CLEAR_CHAT_HISTORY = 'CLEAR_CHAT_HISTORY'
///ADMIN DASHBOARD
export const ADMIN_DASHBOARD_DETAILS = 'ADMIN_DASHBOARD_DETAILS'

/// ADMIN ANALYTICS DASHBOARD (single stored-procedure-backed fetch - views/adminAnalyticsDashboard)
export const ADMIN_ANALYTICS_DASHBOARD_REQUEST = 'ADMIN_ANALYTICS_DASHBOARD_REQUEST'
export const ADMIN_ANALYTICS_DASHBOARD_SUCCESS = 'ADMIN_ANALYTICS_DASHBOARD_SUCCESS'

/// USER ANALYTICS DASHBOARD (single stored-procedure-backed fetch - views/userAnalyticsDashboard)
export const USER_ANALYTICS_DASHBOARD_REQUEST = 'USER_ANALYTICS_DASHBOARD_REQUEST'
export const USER_ANALYTICS_DASHBOARD_SUCCESS = 'USER_ANALYTICS_DASHBOARD_SUCCESS'

/// DASHBOARD LAYOUT PREFERENCE (Customize Layout - shared by both Analytics Dashboards,
/// keyed per-dashboardType in dashboardLayoutReducer.js)
export const DASHBOARD_LAYOUT_REQUEST = 'DASHBOARD_LAYOUT_REQUEST'
export const DASHBOARD_LAYOUT_SUCCESS = 'DASHBOARD_LAYOUT_SUCCESS'
export const DASHBOARD_LAYOUT_FAILURE = 'DASHBOARD_LAYOUT_FAILURE'
export const DASHBOARD_LAYOUT_SAVE_SUCCESS = 'DASHBOARD_LAYOUT_SAVE_SUCCESS'
export const DASHBOARD_LAYOUT_RESET_SUCCESS = 'DASHBOARD_LAYOUT_RESET_SUCCESS'

/// Login wiht otp

export const UPDATE_OTP_LOGIN = 'UPDATE_OTP_LOGIN'
export const UPDATE_RESEND_OTP_LOGIN = 'UPDATE_RESEND_OTP_LOGIN'
export const UPDATE_MFAENABLED = 'UPDATE_MFAENABLED'
export const GET_ALL_MAILS = 'GET_ALL_MAILS'
export const GET_EMAIL_CONTENT = 'GET_EMAIL_CONTENT'
export const GET_LITERATURE_CONTENT = 'GET_LITERATURE_CONTENT'
export const CREATE_LITERATURE_MANAGEMENT = 'CREATE_LITERATURE_MANAGEMENT'
export const CREATE_EMAIL_CONTENT = 'CREATE_EMAIL_CONTENT'
export const CREATE_EMAIL_AND_LITERATURE = 'CREATE_EMAIL_AND_LITERATURE'
export const GET_EMAIL_AND_LITERATURE_CASES = 'GET_EMAIL_AND_LITERATURE_CASES'
export const GET_ONE_EMAIL_AND_LITERATURE_CASES =
  'GET_ONE_EMAIL_AND_LITERATURE_CASES'
export const UPDATE_EMAIL_AND_LITERATURE = 'UPDATE_EMAIL_AND_LITERATURE'
export const GET_ALL_LITERATURE = 'GET_ALL_LITERATURE'
export const GET_TEMPLATE_PDF = 'GET_TEMPLATE_PDF'

//Source Data
export const UPLOAD_PDFFILES = 'UPLOAD_PDFFILES'
export const TRAINING_DATA = 'TRAINING_DATA'
export const ADD_SOURCE_DATA = 'ADD_SOURCE_DATA'
export const GET_SOURCE_DETAILS = 'GET_SOURCE_DETAILS'
export const GET_ALL_SOURCEDATA = 'GET_ALL_SOURCEDATA'
export const GET_UPDATED_MEDWATCH = 'GET_UPDATED_MEDWATCH'
export const GET_UPDATED_CIMOS = 'GET_UPDATED_CIMOS'

//send through the gateway
export const SEND_THROUGH_THE_GATEWAY = 'SEND_THROUGH_THE_GATEWAY'

// AS2 Response Types
export const GET_AS2_RESPONSE_HISTORY = 'GET_AS2_RESPONSE_HISTORY'
export const GET_AS2_RESPONSE_STATS = 'GET_AS2_RESPONSE_STATS'
export const GET_RECENT_AS2_RESPONSES = 'GET_RECENT_AS2_RESPONSES'
export const RETRY_AS2_TRANSMISSION = 'RETRY_AS2_TRANSMISSION'
export const UPDATE_AS2_RESPONSE_STATUS = 'UPDATE_AS2_RESPONSE_STATUS'
export const VIEW_DEMOGRAPHY = 'VIEW_DEMOGRAPHY'
export const GET_ALL_CHECK_LIST = 'GET_ALL_CHECK_LIST'
export const GET_ALL_CHECK_LIST_CASES = 'GET_ALL_CHECK_LIST_CASES'
export const GET_ALL_CHECK_LIST_CASES_Details =
  'GET_ALL_CHECK_LIST_CASES_Details'
//email
export const CREATE_ISREADEMAIL = 'CREATE_ISREADEMAIL'

////ADMIN FIELD MANAGEMENT
export const CREATE_ADMIN_FIELD_MANAGEMENT = 'CREATE_ADMIN_FIELD_MANAGEMENT'

export const CREATE_ADMIN_FIELD_TYPE = 'CREATE_ADMIN_FIELD_TYPE'

// export const GET_ADMIN_FIELD_MANAGEMENT='GET_ADMIN_FIELD_MANAGEMENT'
// export const GET_ADMIN_FIELD_TYPE='GET_ADMIN_FIELD_TYPE'
// export const GET_CHECKING_PERMISSION= 'GET_CHECKING_PERMISSION'

// Excel Upload Types
export const EXCEL_UPLOAD_REQUEST = 'EXCEL_UPLOAD_REQUEST'
export const EXCEL_UPLOAD_SUCCESS = 'EXCEL_UPLOAD_SUCCESS'
export const EXCEL_UPLOAD_FAILURE = 'EXCEL_UPLOAD_FAILURE'

//Create Case From Excel
export const CREATE_CASE_FROM_EXCEL = 'CREATE_CASE_FROM_EXCEL'

//GET ALL CASE FILTER
export const GET_ALL_CASE_FILTER = 'GET_ALL_CASE_FILTER'
export const GET_CHECKING_PERMISSION = 'GET_CHECKING_PERMISSION'
export const GET_ADMIN_FIELD_MANAGEMENT = 'GET_ADMIN_FIELD_MANAGEMENT'
export const GET_ADMIN_FIELD_TYPE = 'GET_ADMIN_FIELD_TYPE'

/// MOBILE ADMIN

/// User Level

export const CREATE_USER_LEVEL = 'CREATE_USER_LEVEL'
export const GET_ALL_USER_LEVEL = 'GET_ALL_USER_LEVEL'
export const UPDATE_USER_LEVEL = 'UPDATE_USER_LEVEL'

//// User Type

export const CREATE_USER_TYPE = 'CREATE_USER_TYPE'
export const GET_ALL_USER_TYPES = 'GET_ALL_USER_TYPES'
export const UPDATE_USER_TYPE = 'UPDATE_USER_TYPE'

/// user Desination

export const CREATE_USER_DESIGNATION = 'CREATE_USER_DESIGNATION'
export const GET_ALL_USER_DESIGNATIONS = 'GET_ALL_USER_DESIGNATIONS'
export const UPDATE_USER_DESIGNATION = 'UPDATE_USER_DESIGNATION'

/// User
export const CREATE_USER = ' CREATE_USER'
export const UPDATE_USER = ' UPDATE_USER'
export const GET_ALL_ADR_USERS = 'GET_ALL_ADR_USERS'

/// DEPART
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT'
export const GET_ALL_DEPARTMENT = 'GET_ALL_DEPARTMENT'
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT'

// Source Tyoe
export const CREATE_SOURCE_TYPE = 'CREATE_SOURCE_TYPE'
export const GET_ALL_SOURCE_TYPE = 'GET_ALL_SOURCE_TYPE'
export const UPDATE_SOURCE_TYPE = 'UPDATE_SOURCE_TYPE'

/// FACILITY

export const CREATE_FACILITY = 'CREATE_FACILITY'
export const GET_ALL_FACILIYS = 'GET_ALL_FACILIYS'
export const UPDATE_FACILITY = 'UPDATE_FACILITY'

/// AGE Group

export const CREATE_AGE_GROUP = 'CREATE_AGE_GROUP'
export const GET_ALL_AGE_GROUP = 'GET_ALL_AGE_GROUP'
export const UPDATE_AGE_GROUP = 'UPDATE_AGE_GROUP'

//// Severity

export const CREATE_SEVERITY = 'CREATE_SEVERITY'
export const GET_ALL_SEVERITY = 'GET_ALL_SEVERITY'
export const UPDATE_SEVERITY = 'UPDATE_SEVERITY'

// RESOLUTION

export const CREATE_RESOLUTION = 'CREATE_RESOLUTION'
export const GET_ALL_RESOLUTION = 'GET_ALL_RESOLUTION'
export const UPDATE_RESOLUTION = 'UPDATE_SEVERITY'

///reporter role

export const CREATE_REPORTER_ROLE = 'CREATE_REPORTER_ROLE'
export const GET_ALL_REPORTER_ROLE = 'GET_ALL_REPORTER_ROLE'
export const UPDATE_REPORTER_ROLE = 'UPDATE_REPORTER_ROLE'

///Naranjo
export const CREATE_NARANJO = 'CREATE_NARANJO'
export const GET_ALL_NARANJO = 'GET_ALL_NARANJO'
export const UPDATE_NARANJO = 'UPDATE_NARANJO'

/// Fields
export const GET_ALL_ADR_ADMIN_FORMS = 'GET_ALL_ADR_ADMIN_FORMS'
export const GET_ALL_ADR_FORM_FIELDS = 'GET_ALL_ADR_FORM_FIELDS'
export const GET_FIELDS_BY_ID = 'GET_FIELDS_BY_ID'
export const UPDATE_ADR_FIELDS = 'UPDATE_ADR_FIELDS'
export const DELETE_FIELD_OPTION = 'DELETE_FIELD_OPTION'

//LITERATURE QUERY
export const CREATE_LITERACTURE_QUERY = 'CREATE_LITERACTURE_QUERY'
export const GET_ALL_LITERACTURE_QUERY = 'GET_ALL_LITERACTURE_QUERY'
export const UPDATE_LITERACTURE_QUERY = 'UPDATE_LITERACTURE_QUERY'
export const INACTIVE_LITERACTURE_QUERY = 'INACTIVE_LITERACTURE_QUERY'

/// gateway regulatory

export const GET_REGULATORY_GATEWAY = 'GET_REGULATORY_GATEWAY'
export const CREATE_GATWAY = 'CREATE_GATWAY'
export const GET_ALL_GATEWAYS = 'GET_ALL_GATEWAYS'
export const UPDATE_GATWAY = 'UPDATE_GATWAY'

///
export const GET_ALL_ADVERSE_EVENTS = 'GET_ALL_ADVERSE_EVENTS'
export const GET_ADVERSE_EVENT_BY_ID = 'GET_ADVERSE_EVENT_BY_ID'
export const CREATE_UPLOAD_CASE = 'CREATE_UPLOAD_CASE'

//

export const ADD_ESIGNATURE = 'ADD_ESIGNATURE'
export const GET_ONE_ESIGNATURE = 'GET_ONE_ESIGNATURE'
export const SUBMIT_REPORT = 'SUBMIT_REPORT'

/// Multisource details
export const CREATE_MULTI_SOURCE_DETAILS = 'CREATE_MULTI_SOURCE_DETAILS'
export const ALL_MULTI_SOURCE = 'ALL_MULTI_SOURCE'
export const UPDATE_MAIN_INFO_CASE = 'UPDATE_MAIN_INFO_CASE'
export const UPDATE_MAIN_INFO_CASE_BULK = 'UPDATE_MAIN_INFO_CASE_BULK'
export const EXTRACTED_ONE_CASE_INFO = 'EXTRACTED_ONE_CASE_INFO'

//
export const ALL_MULTI_SOURCE_INFO = 'ALL_MULTI_SOURCE_INFO'
export const CLEAR_MULTISOURCE = 'CLEAR_MULTISOURCE'
export const UPDATE_FILE_PROGRESS = 'UPDATE_FILE_PROGRESS'

/// Signal Analysis
export const GET_SIGNAL_TABLE = 'GET_SIGNAL_TABLE'
export const GET_SIGNAL_TRENDS = 'GET_SIGNAL_TRENDS'
export const GET_SIGNAL_EMERGING = 'GET_SIGNAL_EMERGING'
export const GET_SIGNAL_FILTER_OPTIONS = 'GET_SIGNAL_FILTER_OPTIONS'
export const GET_SIGNAL_RECORDS = 'GET_SIGNAL_RECORDS'
export const CREATE_SIGNAL_RECORD = 'CREATE_SIGNAL_RECORD'
export const UPDATE_SIGNAL_RECORD = 'UPDATE_SIGNAL_RECORD'
export const GET_DESIGNATED_TERMS = 'GET_DESIGNATED_TERMS'
export const CREATE_DESIGNATED_TERM = 'CREATE_DESIGNATED_TERM'
export const DELETE_DESIGNATED_TERM = 'DELETE_DESIGNATED_TERM'
export const GET_DETECTION_RUNS = 'GET_DETECTION_RUNS'
export const REVIEW_DETECTION_RUN = 'REVIEW_DETECTION_RUN'